import { render, staticRenderFns } from "./SelectUserRole.vue?vue&type=template&id=24edbd7c&scoped=true"
import script from "./SelectUserRole.vue?vue&type=script&lang=js"
export * from "./SelectUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24edbd7c",
  null
  
)

export default component.exports